import styled from 'styled-components'

import { translate } from '../../../../utils/translation'
import { fonts, palette } from '../../../../styles/variables'
import { localizedMoment } from '../../../../utils/functions'
import clockIcon from '../../../../styles/assets/checkoutModal/clock-icon.svg'
import calendarIcon from '../../../../styles/assets/checkoutModal/calendar-icon.svg'
import tickIcon from '../../../../styles/assets/checkoutModal/tick-icon.svg'

const IconWrapper = styled.div(({ active }) => ({
  width: '40px',
  height: '40px',
  borderRadius: '20px',
  border: `1.5px solid ${active ? palette.green : palette.gray50}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}))

const Widget = styled.div({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  gap: '0 20px',
  height: '40px',
})

const Descriptor = styled.div({
  fontSize: '14px',
  lineHeight: '22.4px',
  fontFamily: fonts.primary,
  color: palette.neutral01,
  b: {
    fontFamily: fonts.primaryBook,
    fontWeight: 500,
  },
})

const Connector = styled.div(({ active }) => ({
  borderLeft: `1.5px solid ${active ? palette.green : palette.gray50}`,
  marginLeft: '19px',
  height: '24px',
}))

export default () => {
  return (
    <div>
      <Widget>
        <IconWrapper active>
          <img src={clockIcon} alt="Clock Icon" />
        </IconWrapper>
        <Descriptor
          dangerouslySetInnerHTML={{
            __html: translate('ubs_atp_activates_today'),
          }}
        />
      </Widget>
      <Connector active />
      <Widget>
        <IconWrapper>
          <img src={calendarIcon} alt="Calendar Icon" />
        </IconWrapper>
        <Descriptor
          dangerouslySetInnerHTML={{
            __html: translate(
              'ubs_atp_access_until',
              localizedMoment().add(1, 'year').format('LL'),
            ),
          }}
        />
      </Widget>
      <Connector />
      <Widget>
        <IconWrapper>
          <img src={tickIcon} alt="Tick Icon" />
        </IconWrapper>
        <Descriptor
          dangerouslySetInnerHTML={{
            __html: translate(
              'subscription_starts_on',
              localizedMoment().format('LL'),
            ),
          }}
        />
      </Widget>
    </div>
  )
}
